/** @prettier */

import {Dialog, DialogTitle, DialogContent, DialogActions} from '@mui/material';
import {useState} from 'react';

//MTH component import
import APIErrorMessage from '../../component/APIErrorMessage';
import {PrimaryButton, SecondaryButton} from '../../component/BasicButton';
//API import
import {putSettingLogic} from '../../API/API_Collection';
//interface import
import * as apiIF from '../../Type/api';
//Style import
import '../../css/common/common.css';

import convertLogic from '../../functions/convertLogic';
import {useTranslation} from 'react-i18next';

/**
 * ロジック 削除ダイアログ
 * @param props props
 * - logicInfo ロジック設定情報
 * - targetPriorityLevel 削除するロジックの優先レベル
 * - isOpenDialog ダイアログ表示フラグ
 * - setIsOpenDialog ダイアログ表示フラグ 設定関数
 * - setLogicInfoChange ロジック設定更新フラグ 設定関数
 * @returns JSX
 */
const LogicDeleteDialog = (props: {
  logicInfo: apiIF.res.getSettingLogic;
  targetPriorityLevel: apiIF.res.settingLogic['priority-level'];
  targetLogicName: string;
  targetLogicNumber: number;
  isOpenDialog: boolean;
  setIsOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setLogicInfoChange: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const trans = useTranslation().t; //翻訳関数
  const siteID = props.logicInfo['site-id'];

  const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false); //APIエラー時エラーメッセージ表示
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ

  /**
   * OKボタン押下時処理
   */
  const handleDelete = () => {
    setAPIWait(true);
    //APIに渡すデータ作成
    const editData: apiIF.reqParameters.putSettingLogic = {
      //現在のロジック設定情報を基に作成する
      settings: props.logicInfo['settings'].map(logic => {
        //削除対象のロジック設定を空にする
        if (logic['priority-level'] === props.targetPriorityLevel) {
          return {};
        }

        let tempLogic = logic;
        //削除するロジック設定より下位レベルの設定を上位へ詰める
        if (
          Number(tempLogic['priority-level']) <
          Number(props.targetPriorityLevel)
        ) {
          tempLogic = {
            ...tempLogic,
            'priority-level': String(Number(tempLogic['priority-level']) + 1),
          };
        }
        //ロジック設定をロジック編集APIに渡す形に変換する
        const editLogic = convertLogic(tempLogic);
        return editLogic;
      }),
    };
    //ロジック編集API
    putSettingLogic(siteID, editData)
      .then(response => {
        //ロジック設定更新フラグtrue
        props.setLogicInfoChange(true);
        handleClose();
      })
      .catch(err => {
        setIsOpenErrorDialog(true);
      })
      .finally(() => {
        setAPIWait(false);
      });
  };
  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    props.setIsOpenDialog(false);
  };

  return (
    <>
      <Dialog open={props.isOpenDialog} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          {trans('LogicDeleteDialog.title')}
        </DialogTitle>
        <DialogContent>{trans('LogicDeleteDialog.explanation')}</DialogContent>
        <DialogContent>
          {trans('LogicDeleteDialog.number')}
          {props.targetLogicNumber} : {props.targetLogicName}
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            disabled={apiWait}
            onClick={handleClose}
            buttonText={trans('LogicDeleteDialog.buttonTxt.cancel')}
            id={`logic${props.targetPriorityLevel}DeleteCancelBtn`}
          />
          <PrimaryButton
            onClick={handleDelete}
            buttonText={trans('LogicDeleteDialog.buttonTxt.ok')}
            id={`logic${props.targetPriorityLevel}DeleteOkBtn`}
            apiWait={apiWait}
          />
        </DialogActions>
      </Dialog>
      <APIErrorMessage
        open={isOpenErrorDialog}
        setOpen={setIsOpenErrorDialog}
        id={`logic${props.targetPriorityLevel}DeleteErrDlgBtn`}
      />
    </>
  );
};
export default LogicDeleteDialog;
